import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { fetchDownloadUrlPrintingFileAction } from '../../../reducers/printingFiles';
import OpenWithExternalApp from '../../../components/OpenWithExternalApp';

const IOSFileActions = ({ iosFile, patient }) => {
  const dispatch = useDispatch();

  const handleDownloadFile = id => {
    dispatch(fetchDownloadUrlPrintingFileAction(id));
  };

  if (!iosFile || !iosFile.id) {
    return <span>Invalid IOS file provided</span>;
  }

  return (
    <Grid container>
      <OpenWithExternalApp
        patient={patient}
        fileId={iosFile.id}
        buttonProps={{
          color: 'inherit',
          title: 'Open DIBS',
          key: 'open'
        }}
      />

      <IconButton
        color="inherit"
        title="Download File"
        key="download"
        onClick={() => handleDownloadFile(iosFile.id)}
      >
        <CloudDownloadIcon />
      </IconButton>
    </Grid>
  );
};

IOSFileActions.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  iosFile: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  patient: PropTypes.object.isRequired
};

IOSFileActions.defaultProps = {};

export default IOSFileActions;
